<script>
/**
 * ****************************************************************************
 * @description     :   Main component for popup Area
 * @created at      :   2025/11/26
 * @created by      :   ANS902 - quanlh@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import template from './template.html';
import { mapMutations } from 'vuex';
import QRCode from 'qrcode';

var Qr = {
    template: template,
    created() {
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
        this.id = String(userInfo.staff_id || userInfo.StaffID || '');
    },
    async mounted() {
        await this.generateQrCode();
    },
    data() {
        return {
            id: '',
            qrDataUrl: ''
        };
    },
    emits: ['close'],
    methods: {
        ...mapMutations('app', ['showModalMessage']),
        async generateQrCode() {
            if (!this.id) {
                this.qrDataUrl = '';
                return;
            }

            try {
                this.qrDataUrl = await QRCode.toDataURL(`${this.id}`, {
                    width: 150,
                    margin: 1
                });
            } catch (e) {
                this.qrDataUrl = '';
                this.showModalMessage({
                    type: 3,
                    title: 'エラー',
                    content: 'QRコードを生成できませんでした。'
                });
            }
        },
        closePopup() {
            this.$emit('close');
        }
    }
};
export default Qr;
</script>
